export default {
  "content": "<g clip-path=\"url(#clip0)\"><path d=\"M12 0a12 12 0 100 24 12 12 0 000-24zm3.55 11.83l-3 2A1 1 0 0112 14c-.086.01-.174.01-.26 0a1 1 0 01-.63-.52l-3-6a1 1 0 011.78-.9l2.5 5 2.06-1.37a1 1 0 011.1 1.66v-.04z\" fill=\"#D3D236\"/></g><defs><clipPath id=\"clip0\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};